package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.appcontent.withGodNameHyphenated

class RemoveGodNamesUseCase {

    /** See withGodNameHyphenated() (:appContent, shared with the website). */
    operator fun invoke(pasuk: String): String = pasuk.withGodNameHyphenated()

}
